module.exports = __webpack_public_path__ + "img/Widget.d1b05e07.png";